import {ILogDeviceData} from '../interfaces/log-device-data.interface';
import Device from '../../../utils/device/device';

export class LogDeviceDataBuilder {

    build(): ILogDeviceData {
        let result: ILogDeviceData ={
            userAgent: Device.userAgent,
            screenResolution: Device.viewport.screenWidth + 'x' +  Device.viewport.screenHeight,
            isHybridEmbedded: Device.hybrid.isEmbedded,
            osName: Device.os.name
        };

        return result;
    }

}
